'use client';

import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import { useDispatch, useSelector } from 'react-redux';
import { setSnackbar } from '../../../store/common/common.reducer';
import { snackbarSelector } from '../../../store/common/common.selector';

const CustomSnackbar = () => {
  const dispatch = useDispatch();

  const snackbar = useSelector(snackbarSelector);
  const { message, openSnackbar } = snackbar || {};

  const handleClose = () => dispatch(setSnackbar({ openSnackbar: false, message: '' }));

  return (
    <Snackbar open={openSnackbar} autoHideDuration={5000} onClose={handleClose} message={message} />
  );
};

export default CustomSnackbar;
